import React from "react";
import { PageLayout, HeroElement } from "@bluefin/components";
import { Grid } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class FaqPage extends React.PureComponent {
  render() {
    return (
      <WebsiteLayout>
        <PageLayout
          hero={
            <HeroElement
              header={"FAQ"}
              tagline={""}
              images={[
                "https://fisherman.gumlet.io/public/monicasmercato/mercato_front.jpg",
              ]}
              ctas={[]}
              ctaInverted={true}
              ctaColor={"white"}
              containerColor={"primary"}
              textColor={"white"}
              showMultiple={true}
              overlay={true}
              fullWidth={true}
              parallax={false}
              containerAs={"none"}
              height={500}
            />
          }
          subfooter={false}
          className={"faq-page"}
        >
          <Grid
            stackable={true}
            textAlign={"left"}
            centered={false}
            className={"faq-container"}
          >
            <Grid.Column width={12}>
              <div className={"question-row"}>
                <h3>Q. Do you have seating?</h3>
                <p>
                  A. We do not have onsite seating but there are several indoor
                  and outdoor options nearby.
                </p>
              </div>
            </Grid.Column>
            <Grid.Column width={16}>
              <div className={"question-row"}>
                <h3>Q. What options are nearby for seating?</h3>
                <p>
                  A. We are located 0.3 miles from the Boston Public Market
                  (indoor food court style seating), 700ft from the Defilippo
                  Playground (outdoor park, with benches and tables) and 300ft
                  from Polcari Playground.
                </p>
              </div>
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}
